import { createSelector } from 'reselect'
import { propOr } from 'ramda'
import { isNotNilOrEmpty } from 'utils/ramda'

const getFiles = state => state.files

// More specific selectors to avoid re-renders when unrelated state changes
const getBpFilesList = state => state.files.bpFilesList
const getCurrentBpFilesRaw = state => state.files.currentBpFiles

export const getCurrentBpFiles = createSelector(getCurrentBpFilesRaw, files =>
  (files || []).filter(file => !isNotNilOrEmpty(file.deletedAt))
)

export const selectBpFilesList = createSelector(getBpFilesList, files =>
  (files || []).filter(file => !isNotNilOrEmpty(file.deletedAt))
)

export const selectRecentFiles = createSelector(getFiles, state =>
  propOr([], 'recentFiles', state).filter(
    file => !isNotNilOrEmpty(file.deletedAt)
  )
)

export const isUploading = createSelector(
  getFiles,
  propOr(false, 'isUploading')
)

export const getFileTypes = createSelector(getFiles, propOr({}, 'fileTypes'))

export const selectCurrentUploadProcess = createSelector(
  getFiles,
  propOr(null, 'uploadProcess')
)

export const selectMultiUploadFiles = createSelector(getFiles, state =>
  propOr([], 'multiUploadFiles', state)
)

export const selectFileTagsForBp = createSelector(
  getFiles,
  propOr([], 'fileTags')
)

export const selectRecommendedFileTypes = createSelector(
  getFiles,
  propOr([], 'recommendedFileTypes')
)

export const selectRecommendedFileTypesMessage = createSelector(
  getFiles,
  propOr(null, 'recommendedFileTypesMessage')
)

export const selectFileStatistics = createSelector(
  getFiles,
  propOr(null, 'fileStatistics')
)

export const selectFileStatisticsLoading = createSelector(
  getFiles,
  propOr(false, 'fileStatisticsLoading')
)

export const selectIsLoadingFileTypes = createSelector(
  getFiles,
  propOr(false, 'isLoadingFileTypes')
)

export const selectIsLoadingFileTags = createSelector(
  getFiles,
  propOr(false, 'isLoadingFileTags')
)
const getCustomFolderFilesRaw = state => state.files.customFolderFiles

export const selectCustomFolderFiles = createSelector(
  getCustomFolderFilesRaw,
  files => files || {}
)

export const selectLoadingProgress = createSelector(
  getFiles,
  state => state.loadingProgress || {}
)
